var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"aee7499c940cfc3d8ca5b30c448bd9c92d450afe"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

/**
 * Sentry Client-Side Configuration
 *
 * This file configures Sentry for browser/client-side error tracking,
 * performance monitoring, and session replay. It includes features like:
 * - Error and exception tracking
 * - Performance monitoring with tracing
 * - Session replay for debugging
 * - User feedback integration
 */

import * as Sentry from "@sentry/nextjs";

Sentry.init({
  // Data Source Name - tells Sentry where to send events
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  // Environment tracking (development, staging, production)
  environment: process.env.NODE_ENV,

  // Performance Monitoring
  // In production, sample 10% of transactions for performance
  // In development, sample 100% to catch all issues
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,

  // Define which URLs should have trace propagation
  // This ensures distributed tracing works across our services
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/api\.taskloops\.com/,
    /^\/api\//,
  ],

  // Client-side integrations
  integrations: [
    // Session Replay - records user sessions for debugging
    Sentry.replayIntegration({
      // Mask sensitive text content
      maskAllText: true,
      // Block sensitive media recording
      blockAllMedia: true,
      // Sample rate for normal sessions
      sessionSampleRate: 0.1,
      // Sample rate for error sessions
      errorSampleRate: 1.0,
    }),

    // User Feedback - allows users to submit feedback when errors occur
    Sentry.feedbackIntegration({
      colorScheme: "system",
      showBranding: false,
      autoInject: false, // We'll control when to show feedback
    }),

    // Browser tracing for performance monitoring
    Sentry.browserTracingIntegration({
      // Track navigation and route changes
      enableLongTask: true,
      enableInp: true,
    }),
  ],

  // Session Replay configuration
  // Capture 10% of all sessions, but 100% of sessions with errors
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // Send user IP and request headers (be mindful of privacy)
  sendDefaultPii: false, // We'll set this to false for privacy

  // Release tracking - automatically set by build process
  // Don't set release here, use SENTRY_RELEASE environment variable

  // Configure what data to capture
  beforeSend(event, hint) {
    // Filter out non-actionable errors in production
    if (process.env.NODE_ENV === "production") {
      // Skip certain browser extension errors
      if (event.exception) {
        const error = hint.originalException;
        if (error && typeof error === 'object' && 'message' in error) {
          const message = error.message as string;

          // Skip browser extension errors
          if (
            message.includes('chrome-extension://') ||
            message.includes('moz-extension://') ||
            message.includes('safari-extension://') ||
            message.includes('Non-Error promise rejection')
          ) {
            return null;
          }
        }
      }
    }

    return event;
  },

  // Configure tags for better organization
  initialScope: {
    tags: {
      component: "web-app",
    },
  },
});

// Router transition tracking is now handled automatically by browserTracingIntegration
// in newer versions of Sentry, so no manual export is needed